import API from "../axios";
import APIV2 from "../iventas_api_v2";

import { apiError } from "../observability/apiError";

export const getWaStatusAccount = async (providerId) => {
  try {
    const response = await API.get(
      `/broadcast/get360Status?providerId=${providerId}`
    );
    return response?.data;
  } catch (error) {
    console.log("ERROR_getWaStatusAccount", error);
    throw apiError("ERROR_getWaStatusAccount", error, {
      operation: "getWaStatusAccount",
      module: "utils/broadcast",
    });
  }
};

export const getBroadcastPricing = async (
  channelId,
  templateId,
  tagsIds,
  conjunction
) => {
  try {
    const response = await API.post(`/broadcast/getTotalPricing`, {
      channelId,
      templateId,
      tagsIds,
      conjunction,
    });
    return response?.data;
  } catch (error) {
    console.log("ERROR_getBroadcastPricing", error);
    throw apiError("ERROR_getBroadcastPricing", error, {
      operation: "getBroadcastPricing",
      module: "utils/broadcast",
    });
  }
};

export const createTemplate = async (companyId, channelId, templateData) => {
  try {
    if (!companyId) {
      throw new Error("COMPANY_ID_REQUIRED");
    }
    if (!channelId) {
      throw new Error("CHANNEL_ID_REQUIRED");
    }
    if (!templateData) {
      throw new Error("TEMPLATE_DATA_REQUIRED");
    }

    if (!templateData?.name) {
      throw new Error("TEMPLATE_NAME_REQUIRED");
    }
    if (!templateData?.category) {
      throw new Error("TEMPLATE_CATEGORY_REQUIRED");
    }

    if (!templateData?.text) {
      throw new Error("TEMPLATE_TEXT_REQUIRED");
    }

    const requestPayload = {
      template: {
        name: templateData?.name,
        category: templateData?.category,
        lang: templateData?.lang ?? "es",
        text: templateData?.text,
        type: templateData?.type || "TEXT",
        ...(templateData?.mediaUrl && { mediaUrl: templateData?.mediaUrl }),
        ...(templateData?.variables && { variables: templateData?.variables }),
        ...(templateData?.buttons && { buttons: templateData?.buttons }),
        ...(templateData?.footer && { footer: templateData?.footer }),
      },
    };

    const response = await APIV2.post(
      `/company/${companyId}/channel/${channelId}/templates`,
      requestPayload
    );

    return response?.data;
  } catch (error) {
    // Re-lanza el error enriquecido por el interceptor de iventas_api_v2
    // (errorCode, userMessage, internalCode, httpCode) para que el caller
    // resuelva el mensaje.
    console.log("ERROR_createTemplate", error);
    throw error;
  }
};

export const createBroadcast = async (broadcastData) => {
  try {
    if (!broadcastData) {
      throw new Error("BROADCAST_DATA_REQUIRED");
    }
    if (!broadcastData?.templateName) {
      throw new Error("TEMPLATE_NAME_REQUIRED");
    }
    if (
      !broadcastData?.leads ||
      !Array.isArray(broadcastData?.leads) ||
      broadcastData?.leads.length === 0
    ) {
      throw new Error("LEADS_REQUIRED");
    }
    if (!broadcastData?.token) {
      throw new Error("TOKEN_REQUIRED");
    }

    if (broadcastData?.actions) {
      if (!Array.isArray(broadcastData?.actions)) {
        throw new Error("ACTIONS_MUST_BE_ARRAY");
      }
    }

    if (broadcastData?.sendAt) {
      const sendAtDate = new Date(broadcastData?.sendAt);
      if (isNaN(sendAtDate.getTime())) {
        throw new Error("INVALID_SEND_AT_FORMAT");
      }
    }

    const requestPayload = {
      templateName: broadcastData?.templateName,
      leads: broadcastData?.leads.map((lead) => ({
        phone: lead.phone,
        ...(lead.vars && { vars: lead.vars }),
      })),
      token: broadcastData?.token,
      ...(broadcastData?.fileUrl && { fileUrl: broadcastData?.fileUrl }),
      ...(broadcastData?.name && { name: broadcastData?.name }),
      ...(broadcastData?.sendAt && { sendAt: broadcastData?.sendAt }),
      ...(broadcastData?.actions && { actions: broadcastData?.actions }),
      ...(broadcastData?.phonesToNotify && { phonesToNotify: broadcastData?.phonesToNotify }),
      ...(broadcastData?.tagId && { tagId: broadcastData?.tagId }),
    };

    const response = await APIV2.post("/broadcast", requestPayload);

    return response?.data;
  } catch (error) {
    // Re-lanza el error enriquecido por el interceptor de iventas_api_v2
    // (errorCode, userMessage, internalCode, httpCode) para que el caller
    // resuelva el mensaje.
    console.log("ERROR_createBroadcast", error);
    throw error;
  }
};
